export const UPDATE_FILTER = 'posts/update_filter';
export const UPDATE_SEARCH_TEXT = 'posts/update_search_text';
export const CLEAR_SEARCH_TEXT = 'posts/clear_search_text';
export const CLEAR_FILTER = 'posts/clear_filter';
